var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9551 6.65169C10.9551 5.84644 10.7584 5.09738 10.3652 4.40449C9.95319 3.71161 9.40075 3.15918 8.70787 2.74719C7.99626 2.35393 7.24719 2.1573 6.46068 2.1573C5.67416 2.1573 4.9251 2.35393 4.21349 2.74719C3.5206 3.15918 2.96817 3.71161 2.55618 4.40449C2.16292 5.09738 1.9663 5.84644 1.9663 6.65169C1.9663 7.45693 2.16292 8.20599 2.55618 8.89888C2.96817 9.59176 3.5206 10.1442 4.21349 10.5562C4.9251 10.9494 5.67416 11.1461 6.46068 11.1461C7.24719 11.1461 7.99626 10.9494 8.70787 10.5562C9.40075 10.1442 9.95319 9.59176 10.3652 8.89888C10.7584 8.20599 10.9551 7.45693 10.9551 6.65169ZM10.0843 11.2303C9.07304 12.0543 7.86517 12.4757 6.46068 12.4944C4.81274 12.4569 3.43633 11.8858 2.33146 10.7809C1.2266 9.67603 0.655434 8.29963 0.617981 6.65169C0.655434 5.00375 1.2266 3.62734 2.33146 2.52247C3.43633 1.4176 4.81274 0.846442 6.46068 0.808989C8.10862 0.846442 9.48502 1.4176 10.5899 2.52247C11.6948 3.62734 12.2659 5.00375 12.3034 6.65169C12.2846 8.05618 11.8633 9.26404 11.0393 10.2753L14.8034 14.0393C15.0655 14.3577 15.0655 14.676 14.8034 14.9944C14.485 15.2566 14.1667 15.2566 13.8483 14.9944L10.0843 11.2303Z",
    fill: "#A8B0B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/search-grey.86ec098ebdb642249c9d1ed1bd62afd5.svg";
export { ForwardRef as ReactComponent };